import { render, staticRenderFns } from "./distribution_config.vue?vue&type=template&id=0289837c&scoped=true"
import script from "./distribution_config.vue?vue&type=script&lang=js"
export * from "./distribution_config.vue?vue&type=script&lang=js"
import style0 from "./distribution_config.vue?vue&type=style&index=0&id=0289837c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0289837c",
  null
  
)

export default component.exports